import styled from "styled-components";

export const RadioForm = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    height: 32px;
    align-items: center;
`